import config from '../../config/customer.api'
import {
  Request
} from '../shared/base.requests'
import { DealerSalesClassEnum } from '../../src/shared/enums/dealer.sales.class.enum.js'

const inventoryFilter = {
  namespaced: true,
  state: {
    filterModel: {
      isUsed: null,
      modelId: null,
      brandId: null,
      trans: null,
      color: null,
      body: null,
      yearFrom: null,
      yearTo: null,
      priceFrom: null,
      priceTo: null,
      trim: null,
      page: 1,
      sortBy: null,
      perPage: 12
    },
    filterData: {
      brands: [],
      models: [],
      trims: [],
      bodies: [],
      prices: [],
      years: [],
      activeYearRange: null,
      fullYearRange: null,
      activePriceRange: null,
      fullPriceRange: null
    }
  },
  mutations: {
    setFilterIsUsedAndSortBySalesClass (state, data) {
      state.filterModel.isUsed = data !== DealerSalesClassEnum.NewOnly
      state.filterModel.sortBy = state.filterModel.isUsed ? 'price_asc' : 'added_asc'
    },
    setFilterData (state, data) {
      state.filterData = data
    },
    setFilterModel (state, data) {
      state.filterModel = data
    }
  },
  actions: {
    getFilterData: function (context) {
      return new Promise((resolve, reject) => {
        Request.post(config.getFilterData, context.state.filterModel)
            .then(response => {
              context.commit('setFilterData', response.model)
              resolve()
            })
            .catch(error => {
              console.error('loading dynamic filters failed', error)
              reject()
            })
      })
    },
    updateFilter (context, data) {
      context.commit('setFilterModel', data)
    }
  },
  getters: {
    getFilter (state) {
      return Object.assign({}, state.filterModel)
    },
    getYearsRange (state) {
      return state.filterData.fullYearRange ? state.filterData.fullYearRange : {from: 0, to: 1}
    },
    getYearsLimit (state) {
      return state.filterData.activeYearRange
    },
    getPriceRange (state) {
      return state.filterData.fullPriceRange ? state.filterData.fullPriceRange : {from: 0, to: 1}
    },
    getPriceLimit (state) {
      return state.filterData.activePriceRange
    },
    getPriceValues (state) {
      return Object.assign({}, {from: state.filterModel.priceFrom ? state.filterModel.priceFrom : (state.filterData.activePriceRange ? state.filterData.activePriceRange.from : 0), to: state.filterModel.priceTo ? state.filterModel.priceTo : (state.filterData.activePriceRange ? state.filterData.activePriceRange.to : 1)})
    },
    getYearValues (state) {
      return Object.assign({}, {from: state.filterModel.yearFrom ? state.filterModel.yearFrom : (state.filterData.activeYearRange ? state.filterData.activeYearRange.from : 0), to: state.filterModel.yearTo ? state.filterModel.yearTo : (state.filterData.activeYearRange ? state.filterData.activeYearRange.to : 1)})
    }
  }
}
export default inventoryFilter



// WEBPACK FOOTER //
// ./scripts/src/store/inventory.vauto.filter.module.js